import { render, staticRenderFns } from "./TemplateTab2.vue?vue&type=template&id=4209713e&"
import script from "./TemplateTab2.vue?vue&type=script&lang=ts&"
export * from "./TemplateTab2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports